// extracted by mini-css-extract-plugin
export default {"root":"emptyData_root__1jZ-6","image_inner":"emptyData_image_inner__qcFFu","title":"emptyData_title__PzKns"};